import React from 'react';

import PostLayout from '../../../../Layout/PostLayout';
import PostSidePrimaryActions from '../../PostSidePrimaryActions';
import Footer from './Footer';
import Show from './Show';

function Wrapper({ post, space }: any) {
  return (
    <PostLayout
      post={post}
      postMainContent={<Show post={post} space={space} />}
      postSideContent={<PostSidePrimaryActions post={post} space={space} />}
      stickyFooterButton={<Footer post={post} space={space} />}
    />
  );
}

export default Wrapper;
